// Added by Sejune Oh on 2019-02-16
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import RootStore from '../../index'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { reqSearchPatientOriginal } from './PatientSearchStore.service'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class PatientSearchStore {
    _autoSearchEnabled: boolean = false
    _url: string = ''
    _annoimizedPatientId: string = ''
    _originalPatientId: string = ''
    _originalPatientName: string = ''
    _dataToken: string = ''

    root?: RootStore

    constructor(root: RootStore) {
        this.root = root
        makeAutoObservable(this)
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    getOriginalPatientUser = async (target_url: string, data_token: string, annoimized_id: string) => {
        const {
            data: { patient_id, patient_name },
        } = await reqSearchPatientOriginal({ target_url, data_token, annoimized_id })
        return {
            patient_id,
            patient_name,
        }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    get autoSearchEnabled() {
        return this._autoSearchEnabled
    }

    get url() {
        return this._url
    }

    get annoimizedPatientId() {
        return this._annoimizedPatientId
    }

    get originalPatientId() {
        return this._originalPatientId
    }

    get originalPatientName() {
        return this._originalPatientName
    }

    get dataToken() {
        return this._dataToken
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    setAuthSearchEnabled = (flag: boolean) => {
        this._autoSearchEnabled = flag
    }

    setUrl = (url: string) => {
        this._url = url
    }

    setAnnoimizedPatientId = (annoimizedPatientId: string) => {
        this._annoimizedPatientId = annoimizedPatientId
    }

    setOriginalPatientId = (originalPatientId: string) => {
        this._originalPatientId = originalPatientId
    }

    setOriginalPatientName = (originalPatientName: string) => {
        this._originalPatientName = originalPatientName
    }

    setDataToken = (dataToken: string) => {
        this._dataToken = dataToken
    }
}
